module.exports = __webpack_public_path__ + "rotary_slight_right.svg?b79f47a6e86ac0c7262f9e616efc1f58";


//////////////////
// WEBPACK FOOTER
// ./src/assets/diving_icons/rotary_slight_right.svg
// module id = 213
// module chunks = 0